const breadCrumb = "Lançamento de Notas - Emitir Parecer Descritivo";

const routes = [
  {
    path: "/emitir-parecer-descritivo",
    name: "emitir-parecer-descritivo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/EmitirParecerDescritivo/EmitirParecerDescritivo.vue"),
  },
];

export default routes;
